import Vue from "vue";
export const FEEDBACK_NAMESPACE = "feedback";

export default {
  namespaced: true,
  state: {
    responseDataForMonthModeByDate: {},
    responseDataForGroupModeByDate: {},
  },
  mutations: {
    setResponseDataForMonthModeByDate(
      state,
      { responseDataForMonthMode, key }
    ) {
      Vue.set(
        state.responseDataForMonthModeByDate,
        key,
        responseDataForMonthMode
      );
    },
    setResponseDataForGroupModeByDate(
      state,
      { responseDataForGroupMode, key }
    ) {
      Vue.set(
        state.responseDataForGroupModeByDate,
        key,
        responseDataForGroupMode
      );
    },
    resetResponseData(state) {
      state.responseDataForMonthModeByDate = {};
      state.responseDataForGroupModeByDate = {};
    },
  },
};
